import {Divider} from "antd";
import {useTranslation} from "react-i18next";
import {useApp} from "../../core/context/AppContext";
import {matchesSearch} from "../../core/utils/text-search";
import ResponsiveSelect from "../../core/components/ResponsiveSelect";

export default function ModalitySelectBox (props)
{
    const { t } = useTranslation();
    const { modalities } = useApp()

    // Değer alanı (id ya da caller override ederse name) — "Hepsini Seç" buna göre çalışır.
    const valueKey = props?.fieldNames?.value || 'id';
    const allValues = (modalities || []).map(m => m[valueKey]);

    return (
        <ResponsiveSelect
            mode="multiple"
            allowClear
            // Tekli kullanımda (ör. cihaz formu) antd aramayı kapalı getirir; hep açık olsun.
            showSearch
            options={modalities}
            // Yerel süzme; antd'nin varsayılanı düz toLowerCase olduğu için Türkçe İ/I'da şaşıyor.
            filterOption={(input, option) => matchesSearch(option?.name ?? option?.label, input)}
            fieldNames={{
                label: 'name',
                value: 'id'
            }}
            {...props}
            // Modal seçicide "Hepsini Seç / Temizle" modalin kendi başlığında; dropdownRender yalnız
            // açılır liste hâlinde kullanılır.
            dropdownRender={(menu) => (
                <>
                    <div style={{ display: 'flex', gap: 16, padding: '4px 12px' }}>
                        <a onMouseDown={(e) => e.preventDefault()} onClick={() => props.onChange && props.onChange(allValues)}>
                            {t('Select All')}
                        </a>
                        <a onMouseDown={(e) => e.preventDefault()} onClick={() => props.onChange && props.onChange([])}>
                            {t('Clear')}
                        </a>
                    </div>
                    <Divider style={{ margin: '4px 0' }} />
                    {menu}
                </>
            )}
        />
    )
}
